<template>
  <div>
    <Nav></Nav>
    <b-container fluid="xl">
      <b-row class="mt-3">
        <b-col><h1>Lealtad → Beneficios</h1></b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col>
          <b-button variant="primary" @click="$router.push('/loyalty/benefit')">Nuevo beneficio</b-button>
          <b-button variant="success" @click="openIssue(null)">Emitir a un nivel</b-button>
          <b-button variant="outline-secondary" @click="exportJson">Exportar JSON</b-button>
          <b-button variant="outline-secondary" @click="showImport = true">Importar JSON</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table small striped hover responsive :items="definitions" :fields="fields" :busy="loading">
            <template #cell(active)="data">
              <b-badge :variant="data.item.active ? 'success' : 'secondary'">{{ data.item.active ? 'Activo' : 'Inactivo' }}</b-badge>
            </template>
            <template #cell(buttons)="data">
              <b-button size="sm" variant="warning" @click="$router.push('/loyalty/benefit/' + data.item.id)">Editar</b-button>
              <b-button size="sm" variant="outline-success" @click="openIssue(data.item)">Emitir</b-button>
              <b-button size="sm" variant="outline-secondary" @click="duplicate(data.item)">Duplicar</b-button>
              <b-button size="sm" variant="outline-danger" @click="removeDefinition(data.item)">Eliminar</b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>

    <b-modal v-model="showImport" title="Importar beneficio (JSON)" @ok="importJson" ok-title="Importar">
      <b-form-textarea v-model="importText" rows="10" style="font-family: monospace;" placeholder='{"code":"...","effect_type":"amount_off",...}'></b-form-textarea>
    </b-modal>

    <!-- Emisión masiva por nivel: POST /benefits/issue con segment.tier_code. -->
    <b-modal v-model="showIssue" title="Emitir beneficio a un nivel" ok-title="Emitir"
      :ok-disabled="!issueForm.definition_id || !issueForm.tier_code || issuing" :busy="issuing" @ok="confirmIssue">
      <b-form-group label="Beneficio">
        <b-form-select v-model="issueForm.definition_id" :options="benefitOptions"></b-form-select>
      </b-form-group>
      <b-form-group label="Nivel de lealtad">
        <b-form-select v-model="issueForm.tier_code" :options="tierOptions"></b-form-select>
      </b-form-group>
      <b-alert show variant="warning" class="mb-0">
        Se emite una instancia del cupón a <strong>cada cliente</strong> que hoy está en ese nivel exacto.
        La emisión manual no deduplica: si vuelves a ejecutarla, los clientes reciben otro cupón.
      </b-alert>
    </b-modal>
  </div>
</template>

<script>
import Nav from "../../components/Nav.vue";
import benefitsService from "../../services/benefitsService";
import loyaltyService from "../../services/loyaltyService";

export default {
  name: "beneficios",
  components: { Nav },
  data() {
    return {
      definitions: [],
      tiers: [],
      loading: false,
      showImport: false,
      importText: "",
      showIssue: false,
      issuing: false,
      issueForm: { definition_id: null, tier_code: null },
      fields: [
        { key: "code", label: "Código" },
        { key: "name", label: "Nombre" },
        { key: "effect_type", label: "Efecto" },
        { key: "effect_value", label: "Valor" },
        { key: "trigger_type", label: "Disparador" },
        { key: "active", label: "Estado" },
        { key: "buttons", label: "" },
      ],
    };
  },
  computed: {
    benefitOptions() {
      return [{ value: null, text: "— selecciona un beneficio —" }].concat(
        this.definitions.map((d) => ({ value: d.id, text: d.code + " · " + d.name }))
      );
    },
    tierOptions() {
      return [{ value: null, text: "— selecciona un nivel —" }].concat(
        this.tiers.map((t) => ({ value: t.code, text: t.name + " (rango " + t.rank + ")" }))
      );
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      benefitsService.listDefinitions()
        .then((res) => { this.definitions = res.data || []; })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"))
        .finally(() => (this.loading = false));
    },
    loadTiers() {
      if (this.tiers.length) return;
      loyaltyService.getTiers()
        .then((res) => { this.tiers = res.data || []; })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    // def == null abre el modal sin beneficio preseleccionado (botón de la barra).
    openIssue(def) {
      this.loadTiers();
      this.issueForm = { definition_id: def ? def.id : null, tier_code: null };
      this.showIssue = true;
    },
    confirmIssue(evt) {
      evt.preventDefault();
      this.issuing = true;
      benefitsService.issue({
        definition_id: this.issueForm.definition_id,
        segment: { tier_code: this.issueForm.tier_code },
      })
        .then((res) => {
          const d = res.data || {};
          this.showIssue = false;
          this.makeToast("Listo", "Emitidos " + (d.issued_count || 0) + " de " + (d.targeted || 0) + " clientes del nivel", "success");
        })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"))
        .finally(() => (this.issuing = false));
    },
    removeDefinition(def) {
      this.$bvModal.msgBoxConfirm("¿Eliminar el beneficio " + def.code + "? Si ya tiene cupones emitidos el borrado falla (FK); en ese caso desactívalo desde Editar.", {
        title: "Confirmar", okTitle: "Eliminar", okVariant: "danger", cancelTitle: "Cancelar",
      }).then((ok) => {
        if (!ok) return;
        benefitsService.deleteDefinition(def.id)
          .then(() => { this.load(); this.makeToast("Listo", "Beneficio eliminado", "success"); })
          .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
      });
    },
    duplicate(def) {
      const copy = { ...def };
      delete copy.id;
      copy.code = def.code + "_COPY";
      copy.name = def.name + " (copia)";
      benefitsService.createDefinition(copy)
        .then(() => { this.load(); this.makeToast("Listo", "Beneficio duplicado", "success"); })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    exportJson() {
      const blob = new Blob([JSON.stringify(this.definitions, null, 2)], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "beneficios.json";
      a.click();
      URL.revokeObjectURL(url);
    },
    importJson(evt) {
      evt.preventDefault();
      let data;
      try {
        data = JSON.parse(this.importText);
      } catch (e) {
        this.makeToast("Error", "JSON inválido: " + e.message, "danger");
        return;
      }
      const defs = Array.isArray(data) ? data : [data];
      Promise.all(defs.map((d) => { const c = { ...d }; delete c.id; return benefitsService.createDefinition(c); }))
        .then(() => { this.showImport = false; this.importText = ""; this.load(); this.makeToast("Listo", "Beneficios importados", "success"); })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    errMsg(err) {
      if (err && err.response && err.response.data) {
        return typeof err.response.data === "string" ? err.response.data : (err.response.data.error || JSON.stringify(err.response.data));
      }
      return err && err.message ? err.message : "Error desconocido";
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, { title, variant, autoHideDelay: 5000, appendToast: true });
    },
  },
};
</script>
